// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1JmVC","messages":"Chat_messages__2SAt3","dateDivider":"Chat_dateDivider__2mcpw"};